import React from 'react';
import { Text } from '../Text';
import { Button } from '../Button';
import { Header, HeaderGrid } from './styled';
import { DownArrowIcon } from '../../tempIcons/DownArrowIcon';
import { UpArrowIcon } from '../../tempIcons/UpArrowIcon';
import { CrossIcon } from '../../tempIcons/CrossIcon';
export const CardHeader = ({ id, title, subtitle, headerVariant = 'headingSmall', action, ActionSlot, isCollapsed, onClickCollapse, onClickClose, }) => (React.createElement(Header, null,
    React.createElement(HeaderGrid, null,
        React.createElement(Text, { id: id, variant: headerVariant }, title),
        action && (React.createElement(Button, { variant: "link", onClick: action.onClick }, action.title)),
        ActionSlot,
        onClickCollapse && (React.createElement(Button, { variant: "flat", icon: isCollapsed ? React.createElement(DownArrowIcon, null) : React.createElement(UpArrowIcon, null), onClick: onClickCollapse })),
        onClickClose && (React.createElement(Button, { variant: "flat", icon: React.createElement(CrossIcon, null), onClick: onClickClose, "aria-label": "Close" }))),
    subtitle && React.createElement(Text, { variant: "subheadingSmall" }, subtitle)));
//# sourceMappingURL=CardHeader.js.map